export function oneOfValidator(first: string, second: string) {
  return (control) => {
    let firstValid = !!control.get(first).value && control.get(first).value.toString().length > 0;
    let secondValid = !!control.get(second).value && control.get(second).value.toString().length > 0;
    return firstValid || secondValid ? null : { invalid: true };
  };
}
